import { Stack } from "@mui/material";
import React from "react";
import BarLoader from "react-spinners/BarLoader";
import colors from "../../assets/theme/base/colors";

const LoadingBar = () => {
    return (
        <Stack justifyContent="center" alignItems="center" height="100%">
            <BarLoader color={colors.info.main} />
        </Stack>
    );
};

export default LoadingBar;
